<template >
  <el-dialog title="产品选择" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="70%" style="position: absolute; top: -40px;"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <div class="input_main">
      <div class="main">
        <el-form class="screen-box" title-width="92px" title-align="right" :data="formData"
                 @submit="searchEvent" @reset="searchEvent">
          <div class="main_item">

            <el-form-item>
              <div class="item_items">
                <span>仓库编码:</span>
                <el-input v-model="searchWarehouseCode" placeholder="请输入仓库编码"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="item_items">
                <span>仓库名称:</span>
                <el-input v-model="searchWarehouseName" placeholder="请输入仓库名称"></el-input>
              </div>
            </el-form-item> <el-button class="btn_zdy2" @click="searchEvent">搜索</el-button>
            <!--                  <el-form-item>-->
            <!--                    <div class="item_items">-->
            <!--                      <span>库位编码:</span>-->
            <!--                      <el-input v-model="formData.num3" placeholder="请输入库位编码"></el-input>-->
            <!--                    </div>-->
            <!--                  </el-form-item>-->
            <!--                  <el-form-item>-->
            <!--                    <div class="item_items">-->
            <!--                      <span>库位名称:</span>-->
            <!--                      <el-input v-model="formData.tableDataName2" placeholder="请输入库位名称"></el-input>-->
            <!--                    </div>-->
            <!--                  </el-form-item>-->
          </div>
        </el-form>

      </div>
      <!-- <el-button type="primary" @click="doFilter">搜索</el-button> -->

    </div>
    <template style="margin-top: 40px;">
      <div id="containt" style="margin: 0;">
        <div class="grid-height" style="display:flex;height: 500px;">
          <!-- 左边------- 树型结构 -->
          <div class="table_main" style="height: 500px!important;">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent"
                      show-overflow height="480" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>



          <div class="table_main" style="height: 500px!important;">
            <vxe-grid ref="table-m2" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent1"
                      show-overflow height="443" :row-config="{ isHover: true }"
                      v-bind="vxeOption1" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">


              <template #pager>
                <div style="height: 10px;"></div>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {initVxeTableNoTotal} from "@/const/crud/admin/tableNoTotal";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param'],
  mixins: [selectDialogMixins],
  components: { pager },

  created() {
    this.initSetting();
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      total: 0,
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      vxeOption1: {},
      isRouterAlive: true,
      searchWarehouseName: null,
      searchWarehouseCode: null,
      // 查询参数
      requestParam: {
        current: 1,
        searchCount: false,
        usable: 1,
        warehouseName: null,
        warehouseCode: null
      },
      formData: {
        warehouseId: null,  // 仓库ID,关联bas_warehouse.id
        locationId: null,  // 库位id
        locationName: null,  // 库位名称
        warehouseName: null  // 显示用
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      }
    };
  },

  computed: {
    getDataParams() {
      return {warehouseId: this.formData.warehouseId, usable: 1}
    }
  },

  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    flushed1() {
      this.$refs['table-m2'].commitProxy('reload');
    },

    cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },

    // 仓库选中
    radioChangeEvent ({ row }) {
      console.log('仓库选中', row)
      this.formData.warehouseId = row.id
      this.formData.warehouseName = row.warehouseName
      this.initTableList1()
    },

    // 库位选中
    radioChangeEvent1 ({ row }) {
      console.log('库位选中', row)
      this.formData.locationId = row.id
      this.formData.locationName = row.locationName
    },


    commitRow() {
      this.$emit('commit', this.formData)
      this.dialogClose()
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.initTableList();
    },

    // 搜索
    searchEvent() {
      this.requestParam.warehouseCode = this.searchWarehouseCode
      this.requestParam.warehouseName = this.searchWarehouseName
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // // 重置
    // resetEvent() {
    //   this.searchItemCode = ''
    //   this.searchItemName = ''
    //   this.searchBrandName = ''
    //   this.formData.itemCode = ''
    //   this.formData.itemName = ''
    //   this.formData.brandName = ''
    // 	this.formData.current = 1
    //   this.formData.searchCount = false
    //   this.formData.bigCategoryId = ''
    //   this.formData.smallCategoryId = ''
    // 	this.$refs.pager.reset()  // 重置分页器
    // 	this.flushed()
    //   this.reloadTree()
    // },


    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.basWarehouse.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: [
          { type: 'radio', width: 48, resizable: false,  },
          { title: '仓库编码', field: 'warehouseCode', width: 100, },
          { title: '仓库名称', field: 'warehouseName', width: 100, },
          { title: '仓库类型', field: 'warehouseType', width: 100, slots: {
              default: ({row}) => {
                if (row.warehouseType == 0) {
                  return [
                    <div>
                      <span>总部仓</span>
                    </div>
                  ];
                } else if (row.warehouseType == 1) {
                  return [
                    <div>
                      <span>机构仓</span>
                    </div>
                  ];
                } else if (row.warehouseType == 2) {
                  return [
                    <div>
                      <span>代理仓</span>
                    </div>
                  ];
                } else if (row.warehouseType == 3) {
                  return [
                    <div>
                      <span>网点仓</span>
                    </div>
                  ];
                }
              }
            }},
          { title: '是否配件仓态', field: 'isPartsWare', width: 100, slots: {
              default: ({row}) => {
                if (row.isPartsWare == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>否</span>
                    </div>
                  ];
                } else if (row.isPartsWare == 1) {
                  return [
                    <div class="txt-status">
                      <span>是</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '是否产品仓', field: 'isItemWare', width: 100, slots: {
              default: ({row}) => {
                if (row.isItemWare == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>否</span>
                    </div>
                  ];
                } else if (row.isItemWare == 1) {
                  return [
                    <div class="txt-status">
                      <span>是</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '启用', field: 'usable', width: 100, slots: {
              default: ({row}) => {
                if (row.usable == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>禁用</span>
                    </div>
                  ];
                } else if (row.usable == 1) {
                  return [
                    <div class="txt-status">
                      <span>启用</span>
                    </div>
                  ];
                }
              }
            }
          },
        ]
      };
      this.vxeOption = initVxeTable(tableOption)
      this.flushed()
    },

    initTableList1() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.basWarehouseLocation.getListDataUrl,
        // param: this.formData, 在initVxeTableNoTotal直接调用计算属性，在此处传js内获取不到响应式数据
        method: 'post',
        columns: [
          { type: 'radio', width: 48, resizable: false,  },
          { title: '仓库名称', field: 'warehouseName', width: 100, },
          { title: '库位编码', field: 'locationCode', width: 100, },
          { title: '库位名称', field: 'locationName', width: 100, },
          { title: '仓管员', field: 'warehouseMan', width: 90, },
          { title: '启用', field: 'usable', width: 90, slots: {
              default: ({row}) => {
                if (row.usable == 1) {
                  return [
                    <div class="txt-status">
                      <span>启用</span>
                    </div>
                  ];
                } else if (row.usable == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>禁用</span>
                    </div>
                  ];
                }
              }
            }
          },
          { width: 60, title: '操作', sortable: false, fixed: 'right', slots: {
              default: ({row}) => {
                return [
                  <div>
                    <a href="javascript:void(0);"
                       class="a-link"
                       onclick={ () => {
                         this.openEditDialog(row.id);
                       }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        ]
      };
      this.vxeOption1 = initVxeTableNoTotal(tableOption)
      this.flushed1()
    },




  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 50%);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}
.input_main {
  margin-left: 10px;

  .main {
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .main_item {

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      background-color: #F4F6FA;
      padding-top: 8px;
      //   margin: 0px 0px 5px 0px;
      border-top: solid 1px #E9E9E9;
      //   border-bottom: solid 1px #E9E9E9;

      .item_items {
        display: flex;
        margin-bottom: 8px;

        span {
          width: 112px;
          font-weight: 400;
          text-align: right;
          line-height: 28px;
          font-size: 12px;
          position: relative;
          padding: 0 10px 0 4px;
          color: rgba(86, 86, 86, 0.96);
        }

        .el-input {
          width: 60%
        }
      }
    }
  }

}
::v-deep .el-dialog__body{
  padding-top: 0!important;
}
.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  height: 27px;
  line-height: 1px;
  margin-top: 2px;;
  margin-left: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #e9af57 !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

</style>
